<template>
  <vxe-modal v-model="visible" :loading="loading" title="title.loadingOrderEdit" type="confirm" width="40%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="{span:8}" :model="order" :rules="rules" :wrapper-col="{span:16}">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.loadingOrderNo')" :label-col="{span:4}" :wrapper-col="{span:20}">
            <vxe-input v-model="order.no" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.dispatcher')">
            <vxe-input v-model="order.dispatcher" :editable="false" style="width: 100%" @click="()=>$refs.deliverModal.open({'role.name':'配送员'})"/>
            <user-modal ref="deliverModal" @change="(e)=>{order.dispatcher=e.length===0?null:e[0].name}"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.deliver')" prop="deliver">
            <vxe-input v-model="order.deliverer" :editable="false" style="width: 100%" @click="()=>$refs.deliverModal.open({'role.name':'配送员'})"/>
            <user-modal ref="deliverModal" @change="(e)=>{order.deliverer=e.length===0?null:e[0].name}"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.driver')" prop="driver">
            <vxe-input v-model="order.driver" :editable="false" style="width: 100%" @click="()=>$refs.driverModal.open({'role.name':'司机'})"/>
            <user-modal ref="driverModal" @change="(e)=>{order.driver=e.length===0?null:e[0].name}"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.phone')" prop="driverPhone">
            <vxe-input v-model="order.driverPhone" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.vehicleNo')" prop="vehicleNo">
            <vxe-input v-model="order.vehicle.no" :editable="false" style="width: 100%" @click="()=>$refs.vehicleModal.open()"/>
            <vehicle-modal ref="vehicleModal" @change="(e)=>{order.vehicle=e.length===0?{id:null,no:null}:e[0]}"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.vehicleInPlaceStatus')" prop="vehicleInPlaceStatus">
            <vxe-input v-model="order.vehicleInPlaceStatus" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.departureTime')" prop="departureTime">
            <vxe-date-picker v-model="order.departureTime" style="width: 100%" type="datetime"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.dock')" prop="dock">
            <vxe-input v-model="order.dock.no" :editable="false" style="width: 100%" @click="()=>$refs.dockModal.open({locationType:3})"/>
            <location-modal ref="dockModal" @change="(e)=>{order.dock=e.length===0?{id:null,no:null}:e[0]}"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.notes')" :label-col="{span:4}" :wrapper-col="{span:20}">
            <vxe-textarea v-model="order.notes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import { post } from '@/api/Api'
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import api from '@/api'
import UserModal from '@/views/modal/UserModal.vue'
import LocationModal from '@/views/modal/LocationModel.vue'
import VehicleModal from '@/views/modal/VehicleModal.vue'
import TextAreaModal from '@/views/modal/TextAreaModal.vue'
import { LoadingOrder } from '@/api/dto/order/LoadingOrder'

export default {
  name: 'LoadingOrderEditor',
  components: { TextAreaModal, VehicleModal, LocationModal, UserModal },
  data() {
    return {
      visible: false,
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      order: new LoadingOrder(),
      args: {
        ids: [],
        orderNos: [],
        dispatcher: null,
        deliverer: null,
        driver: null,
        driverPhone: null,
        vehicleInPlaceStatus: null,
        departureTime: null,
        notes: null,
        vehicle: {
          id: null,
          no: null
        },
        dock: {
          id: null,
          no: null
        }
      },
      rules: {},
      record: null
    }
  },
  methods: {
    open(records) {
      console.log(records)
      if (records.length > 0) {
        records.forEach(record => {
          this.args.ids.push(record.order.id)
          this.args.orderNos.push(record.order.no)
        })
      }
      if (records.length === 1) {
        this.args.dispatcher = records[0].order.dispatcher
        this.args.deliverer = records[0].order.deliverer
        this.args.driver = records[0].order.driver
        this.args.driverPhone = records[0].order.driverPhone
        this.args.vehicleInPlaceStatus = records[0].order.vehicleInPlaceStatus
        this.args.departureTime = records[0].order.departureTime
        this.args.notes = records[0].order.notes
        this.args.vehicle = records[0].vehicle === null || records[0].vehicle === undefined ? this.args.vehicle : records[0].vehicle
        this.args.dock = records[0].dock === null || records[0].dock === undefined ? this.args.dock : records[0].dock
      }
      this.visible = true
    },
    save() {
      this.loading = true
      const args = {
        ids: [this.order.id],
        dispatcher: this.order.dispatcher,
        deliverer: this.order.deliverer,
        driver: this.order.driver,
        driverPhone: this.order.driverPhone,
        'vehicle.id': this.order.vehicle.id,
        vehicleInPlaceStatus: this.order.vehicleInPlaceStatus,
        departureTime: this.order.departureTime,
        'dock.id': this.order.dock.id,
        notes: this.order.notes
      }
      post(api.deliveryCheckIn, {}, args).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('postSave')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    }
  }
}
</script>